module.exports = __webpack_public_path__ + "0a7e2fe654029e7ae419391f6e63ee4a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/makeup-gold.png
// module id = 1846
// module chunks = 0